import { render, staticRenderFns } from "./ReportBank.vue?vue&type=template&id=ca88d5cc&"
import script from "./ReportBank.vue?vue&type=script&lang=js&"
export * from "./ReportBank.vue?vue&type=script&lang=js&"
import style0 from "./ReportBank.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports